import { Context } from '@nuxt/types';
import buildTagUrl from '@root/modules/tags/utils/buildTagUrl';
import channels from '@root/modules/channel/config/channel.config';
import { Data as TagData } from '@root/modules/tags/types/tags';
import { buildQueryUrl } from '@root/router/utils/buildQueryUrl';

interface TagContext {
  domain: string;
  locale: string;
  lang: string;
  routeId: string;
  fakeDomainEnabled: boolean;
  query: Context['route']['query'];
  route: Context['route'];
}

const getTagPath = (tag: TagData, { domain, locale, routeId, fakeDomainEnabled, query, route }: TagContext) => {
  if (!tag) {
    return null;
  }

  const tagChannel = channels.find((channel) => channel.tag_channel && channel.locale === locale);
  const sameChannel = tagChannel?.url === domain;

  // handle internal current channel urls or if tag and tag lang don't belong to current channel
  if (sameChannel && String(tag.id) === routeId) {
    return null;
  }

  let tagUrl = buildTagUrl({ tag, domain, locale, fakeDomainEnabled });

  if (query) {
    const queryUrl = buildQueryUrl(tagUrl, { query, route });
    tagUrl = queryUrl;
  }

  if (tagUrl) {
    return tagUrl;
  }

  return null;
};

export default getTagPath;
